import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import {
  allCrudNames,
  allPages,
  checkPageAccess
} from '../../../lib/AllPageNames'
import NotFound from '../../NotFound/NotFound'
import { setPageTitle } from '../../redux/slice/pageTitleSlice'
import ActiveCouponList from './CouponList/ActiveCouponList'
import ExpiredCouponList from './CouponList/ExpiredCouponList'

function ManageCoupons() {
  const [activeToggle, setActiveToggle] = useState('coupon')
  const { pageAccess } = useSelector((state) => state.user)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setPageTitle('Manage Coupon'))
  }, [])

  return checkPageAccess(
    pageAccess,
    allPages?.manageCoupon,
    allCrudNames?.read
  ) ? (
    <>
      <div className='card'>
        <div className='card-body p-0'>
          <div className='nav-tabs-horizontal nav nav-tabs'>
            <Link
              onClick={() => setActiveToggle('coupon')}
              data-toggle='tab'
              className={`nav-link fw-semibold ${
                activeToggle === 'coupon' ? 'active show' : ''
              }`}
            >
              <span className='nav-span'>
                Coupon
                <hr />
              </span>
            </Link>
            <Link
              onClick={() => setActiveToggle('expiredCoupons')}
              data-toggle='tab'
              className={`nav-link fw-semibold ${
                activeToggle === 'expiredCoupons' ? 'active show' : ''
              }`}
            >
              <span className='nav-span'>
                Expired Coupons
                <hr />
              </span>
            </Link>
          </div>

          <div className='tab-content p-3'>
            <div
              id='coupon'
              className={`tab-pane fade ${
                activeToggle === 'coupon' ? 'active show' : ''
              }`}
            >
              {activeToggle === 'coupon' && (
                <>
                  <ActiveCouponList />
                </>
              )}
            </div>

            <div
              id='coupon'
              className={`tab-pane fade ${
                activeToggle === 'expiredCoupons' ? 'active show' : ''
              }`}
            >
              {activeToggle === 'expiredCoupons' && (
                <>
                  <ExpiredCouponList />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  ) : (
    <NotFound />
  )
}

export default ManageCoupons
